// oxlint-disable prisma/safe-local-storage
import { useState, useEffect } from 'react';

function isNewDesignActive() {
  // during unit tests the old design is currently enforced
  // during stroybook tests (vitest) we don't want to enforce the old design
  // we should change this as soon as the feature toggle is public
  if (
    process.env.NODE_ENV === 'test' &&
    !(window as any).__PRISMA_STORY_CONTEXT__
  )
    return false;
  return document.documentElement.getAttribute('data-theme') !== 'legacy';
}

export function useIsNewDesignActive() {
  const [active, setActive] = useState(isNewDesignActive());

  // listen for attribute changes
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-theme') {
          setActive(
            document.documentElement.getAttribute('data-theme') !== 'legacy'
          );
        }
      });
    });
    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return active;
}

export function toggleNewDesign() {
  if (isNewDesignActive()) {
    localStorage.setItem('PRISMA_NEW_DESIGN_OPT_OUT', 'true');
    document.documentElement.setAttribute('data-theme', 'legacy');
  } else {
    localStorage.removeItem('PRISMA_NEW_DESIGN_OPT_OUT');
    document.documentElement.removeAttribute('data-theme');
  }
}

function setNewDesign() {
  localStorage.removeItem('PRISMA_NEW_DESIGN_OPT_OUT');
  document.documentElement.removeAttribute('data-theme');
}

// force new design
// only when running in actual browser, not during build
if (typeof document !== 'undefined') setNewDesign();
